import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { useFocus } from '../../hooks/use_focus.js';
import { bindRefs } from '../../utils/react.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["autosize", "as", "onBlur", "onFocus", "style", "value"];

function measureTextWidth() {
  var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var inputElement = arguments.length > 1 ? arguments[1] : undefined;
  var style = window.getComputedStyle(inputElement, null);
  var canvas = document.createElement("canvas");
  var context = canvas.getContext("2d");
  if (context) context.font = style.font;
  return "calc(".concat(Math.ceil((context === null || context === void 0 ? void 0 : context.measureText(String(txt)).width) || 2), "px + ").concat(style.paddingLeft, " + ").concat(style.paddingRight);
}

var defaultElement = "input";
var getInputStyles = function getInputStyles(props) {
  return {
    background: "none",
    borderWidth: 0,
    color: "currentColor",
    cursor: props.disabled ? "not-allowed" : "auto",
    display: "block",
    font: "inherit",
    lineHeight: "normal",
    margin: 0,
    padding: 0,
    outline: 0,
    width: "100%",
    textOverflow: "ellipsis",
    minWidth: 0,
    "::placeholder": {
      color: props.error ? props.theme.alertColors.error : props.theme.neutralColors.rhino,
      opacity: 1
    },
    "::-ms-clear": {
      display: "none"
    }
  };
};
var StyledInput = styled.input.withConfig({
  displayName: "InputInput__StyledInput",
  componentId: "npzdgx-0"
})(getInputStyles);
var InputInput = /*#__PURE__*/React.forwardRef(function InputInput2(props, ref) {
  var autosize = props.autosize,
      _props$as = props.as,
      as = _props$as === void 0 ? defaultElement : _props$as,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      style = props.style,
      value = props.value,
      rest = _objectWithoutProperties(props, _excluded);

  var _useFocus = useFocus({
    disabled: rest.disabled,
    onFocus: onFocus,
    onBlur: onBlur
  }),
      handleBlur = _useFocus.handleBlur,
      handleFocus = _useFocus.handleFocus,
      inputRef = _useFocus.inputRef;

  var inputElementProps = _objectSpread(_objectSpread({}, rest), {}, {
    onBlur: handleBlur,
    onFocus: handleFocus
  });

  var width = autosize && inputRef.current ? measureTextWidth(value || rest.placeholder, inputRef.current) : style === null || style === void 0 ? void 0 : style.width;
  return /*#__PURE__*/jsx(StyledInput, _objectSpread(_objectSpread({}, inputElementProps), {}, {
    as: as,
    ref: bindRefs(inputRef, ref),
    style: _objectSpread({
      width: width
    }, style),
    value: value
  }));
});
InputInput.propTypes = {
  "as": _PropTypes.oneOfType([_PropTypes.string, _PropTypes.func, _PropTypes.object]),
  "autosize": _PropTypes.bool,
  "disabled": _PropTypes.bool,
  "onBlur": _PropTypes.func,
  "onFocus": _PropTypes.func,
  "placeholder": _PropTypes.string,
  "style": _PropTypes.object,
  "value": _PropTypes.oneOfType([_PropTypes.arrayOf(_PropTypes.string), _PropTypes.number, _PropTypes.string])
};
InputInput.displayName = "InputInput";

export { InputInput, getInputStyles };
